import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Logo from "../elements/Logo";
import Button from "../elements/buttons/Button";
import { useMediaQuery } from "react-responsive";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import SVGLogo from "../../images/brand.svg";

const variants = {
  hidden: { opacity: 0, y: -100 },
  visible: { opacity: 1, y: 0 },
};

const variantsMenu = {
  hidden: { opacity: 0, y: -100 },
  visible: { opacity: 1, y: 0 },
};

const Header = () => {
  const [activeMenu, setActiveMenu] = useState(false);
  const [show, setShow] = useState(true);

  const isSmall = useMediaQuery({
    query: "(max-width: 1120px)",
  });
  const isMobile = useMediaQuery({
    query: "(max-width: 995px)",
  });

  useEffect(() => {
    let top = window.pageYOffset;
    const onScroll = () => {
      let current = window.pageYOffset;
      if (top > current) {
        setShow(true);
      } else {
        setShow(false);
      }
      top = current;
    };

    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <>
      <motion.header
        className="header"
        variants={variants}
        animate={!show && !activeMenu && !isMobile ? "hidden" : "show"}
        transition={{
          type: "Inertia",
        }}
      >
        {!isSmall ? (
          <div className="wrap">
            <Logo />
            <Button
              id="suscribiteBtn"
              copy="Suscríbete"
              link="/"
              className="button-primary"
            />
            <Navbar />
          </div>
        ) : (
          <div className="small-container">
            <div
              className="btn-menu"
              onClick={() => {
                setActiveMenu(!activeMenu);
              }}
            >
              <input type="checkbox" id="toggleMenu" checked={activeMenu} />
              <label for="toggle"></label>
            </div>
            <NavLink to="/" className="button-logo">
              <img
                src={SVGLogo}
                className="logo-small-navbar"
                alt="Logo de XDneo"
                title="XDneo"
              />
            </NavLink>
            <Button copy="Suscríbete" link="/" className="button-primary" />
          </div>
        )}
      </motion.header>
      <div
        className={`menu-container fade ${activeMenu && isSmall && "active"}`}
      >
        <ul>
          <li>
            <NavLink className="btn-menu-mobile" to="/canales">
              Canales
            </NavLink>
          </li>
          <li>
            <NavLink className="btn-menu-mobile" to="/guia">
              Guía
            </NavLink>
          </li>
          <li>
            <NavLink className="btn-menu-mobile" to="/cartelera">
              Cartelera
            </NavLink>
          </li>
          <li>
            <NavLink className="btn-menu-mobile" to="/planes">
              Planes
            </NavLink>
          </li>
          <li>
            <NavLink className="btn-menu-mobile" to="/dispositivos">
              Dispositivos
            </NavLink>
          </li>
          <li>
            <NavLink className="btn-menu-mobile" to="/ayuda">
              Ayuda
            </NavLink>
          </li>
        </ul>
        <div className="login-container">
          <Button copy="Iniciar sesión" link="#" className="button-gradient" />
        </div>
      </div>
    </>
  );
};

export default Header;
